import Debug from './Debug.jsx'

export default Debug
